import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable, postConstruct } from 'mana-syringe';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowEdgeCommands, XFlowNodeCommands } from '../constant';
export var NsHighlightNode;
(function (NsHighlightNode) {
    NsHighlightNode.command = XFlowNodeCommands.HIGHLIGHT_NODE;
    NsHighlightNode.hookKey = 'highlightNode';
})(NsHighlightNode || (NsHighlightNode = {}));
let HighlightNodeCommand = class HighlightNodeCommand {
    constructor() {
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const { args, hooks: runtimeHook } = this.ctx.getArgs();
            const hooks = this.ctx.getHooks();
            const result = yield hooks.highlightNode.call(args, (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const x6Graph = yield this.ctx.getX6Graph();
                const { nodeId, stroke, strokeWidth } = handlerArgs;
                const x6Node = x6Graph === null || x6Graph === void 0 ? void 0 : x6Graph.getCellById(nodeId);
                if (!x6Node) {
                    console.error(nodeId, 'this nodeId is not exist');
                    return { err: 'this nodeId is not exist' };
                }
                else {
                    /** 高亮节点 */
                    x6Node === null || x6Node === void 0 ? void 0 : x6Node.setAttrs({
                        body: {
                            stroke: stroke || '#7c68fc',
                            strokeWidth: strokeWidth || 2,
                        },
                    });
                    /** 节点关联的连线, 联动高亮 */
                    if (handlerArgs === null || handlerArgs === void 0 ? void 0 : handlerArgs.isHighlightRelatedLines) {
                        const { edgeStroke, edgeStrokeWidth } = handlerArgs;
                        const allEdges = x6Graph === null || x6Graph === void 0 ? void 0 : x6Graph.getEdges();
                        allEdges.forEach((x6Edge) => {
                            const x6EdgeData = x6Edge === null || x6Edge === void 0 ? void 0 : x6Edge.getData();
                            handlerArgs === null || handlerArgs === void 0 ? void 0 : handlerArgs.commandService.executeCommand(XFlowEdgeCommands.HIGHLIGHT_EDGE.id, {
                                edgeId: x6EdgeData === null || x6EdgeData === void 0 ? void 0 : x6EdgeData.id,
                                strokeColor: edgeStroke,
                                strokeWidth: edgeStrokeWidth,
                            });
                        });
                    }
                }
                return { err: null };
            }), runtimeHook);
            this.ctx.setResult(result);
            return this;
        });
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            this.ctx.undo();
            return this;
        });
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.ctx.isUndoable) {
                yield this.execute();
            }
            return this;
        });
    }
    init() {
        this.ctx = this.contextProvider();
    }
    isUndoable() {
        return this.ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], HighlightNodeCommand.prototype, "contextProvider", void 0);
__decorate([
    postConstruct(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], HighlightNodeCommand.prototype, "init", null);
HighlightNodeCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsHighlightNode.command.id },
    })
    /** 节点高亮 */
], HighlightNodeCommand);
export { HighlightNodeCommand };
//# sourceMappingURL=node-highlight.js.map